import { render } from "./ModuleModal.vue?vue&type=template&id=6d033393&scoped=true"
import script from "./ModuleModal.vue?vue&type=script&lang=js"
export * from "./ModuleModal.vue?vue&type=script&lang=js"

import "./ModuleModal.vue?vue&type=style&index=0&id=6d033393&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d033393"]])

export default __exports__